import React from 'react';

export function BasicInformation({ report }) {
  return <div className='basicInfo'>
    <div className='title'>{ report.entityName }</div>
    <div className='subtitle'>Basic Information</div>
    <div className='body' dangerouslySetInnerHTML={ { __html: report.basicInformation } } />
  </div>
}